import {
  Module, VuexModule, Mutation, Action
} from 'vuex-module-decorators';
import api from '@/api/club';

@Module({ namespaced: true })
export default class extends VuexModule {
  @Action
  async list(params: any) {
    return api.list(params);
  }

  @Action
  async detail(params: any) {
    return api.detail(params);
  }

  @Action
  async edit(params: any) {
    return api.edit(params);
  }

  @Action
  async delete(params: any) {
    return api.delete(params);
  }

  @Action
  async members(params: any) {
    return api.members(params);
  }

  @Action
  async activity_bulletins(params: any) {
    return api.activity_bulletins(params);
  }

  @Action
  async activities(params: any) {
    return api.activities(params);
  }
}
